/**
 * Maps human-agent `/api/v1/settings` JSON (snake_case) to dashboard shapes (camelCase) and back.
 */

/** @typedef {{ chatFirstResponseSeconds: number, chatAverageResponseSeconds: number, ticketFirstResponseSeconds: number, ticketAverageResponseSeconds: number }} SlaSettings */

/** @param {Record<string, unknown>} row */
export function mapSlaFromApi(row) {
  const n = (v, d) => {
    const x = typeof v === "number" ? v : parseInt(String(v), 10);
    return Number.isFinite(x) && x >= 1 ? x : d;
  };
  return {
    chatFirstResponseSeconds: n(row.chat_first_response_seconds, 60),
    chatAverageResponseSeconds: n(row.chat_average_response_seconds, 50),
    ticketFirstResponseSeconds: n(row.ticket_first_response_seconds, 3600),
    ticketAverageResponseSeconds: n(row.ticket_average_response_seconds, 3600),
  };
}

/** @param {SlaSettings} data */
export function mapSlaToApi(data) {
  return {
    chat_first_response_seconds: data.chatFirstResponseSeconds,
    chat_average_response_seconds: data.chatAverageResponseSeconds,
    ticket_first_response_seconds: data.ticketFirstResponseSeconds,
    ticket_average_response_seconds: data.ticketAverageResponseSeconds,
  };
}

/**
 * @param {Record<string, unknown>} row
 * @returns {{ emailNotif: boolean, desktopNotif: boolean, soundNotif: boolean }}
 */
export function mapNotificationsFromApi(row) {
  return {
    emailNotif: Boolean(row.email_notifications),
    desktopNotif: Boolean(row.desktop_notifications),
    soundNotif: Boolean(row.sound_notifications),
  };
}

/** @param {{ emailNotif: boolean, desktopNotif: boolean, soundNotif: boolean }} t */
export function mapNotificationsToApi(t) {
  return {
    email_notifications: Boolean(t.emailNotif),
    desktop_notifications: Boolean(t.desktopNotif),
    sound_notifications: Boolean(t.soundNotif),
  };
}

/**
 * @param {Record<string, unknown>} row
 * @returns {{ supportEmail: string, timezone: string, language: string }}
 */
export function mapOrgDefaultsFromApi(row) {
  return {
    supportEmail: row.support_email != null ? String(row.support_email) : "",
    timezone: row.timezone != null ? String(row.timezone) : "UTC",
    language: row.language != null ? String(row.language) : "English",
  };
}

/** @param {{ supportEmail: string, timezone: string, language: string }} o */
export function mapOrgDefaultsToApi(o) {
  const se = (o.supportEmail || "").trim();
  return {
    support_email: se || null,
    timezone: (o.timezone || "UTC").trim() || "UTC",
    language: (o.language || "English").trim() || "English",
  };
}
